<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <div class="row">
          <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
            <v-btn
              class="btn-return"
              @click="$router.push({ name: 'semiology-forms' })"
            >
              <i class="fas fa-arrow-left mr-2 text-twenty" /> VOLTAR
            </v-btn>
          </div>
          <div class="col-xl-5 col-lg-5 col-md-6 col-sm-9 col-12 pt-0">
            <h1 class="title-pages pt-1 check-text-center">
              FORMULÁRIO: {{ form.name }}
            </h1>
          </div>
          <div
            class="col-xl-6 col-lg-5 col-md-4 col-sm-12 col-12 pt-0 check-text-right"
          >
            <v-btn class="btn-duplicate m-1" @click="duplicate">
              <i class="fas fa-clone mr-2 text-twenty" /> DUPLICAR
            </v-btn>
            <confirmation-dialog
              v-if="false"
              message-title="DESEJA REALMENTE EXCLUIR?"
              message-body="Ao remover esse formulário serão perdidos todos os dados!"
              open-class="btn-delete m-1"
              open-left-icon="fa-trash mr-2"
              open-text="EXCLUIR"
              yesClass="btn-delete"
              @yes="removeForm"
            />
          </div>
        </div>
        <b-row>
          <b-col>
            <form-details
              :form="form"
              :residents="residents"
              :reorder_mode="reorder_mode"
              @updated="getForm"
            />
          </b-col>
        </b-row>
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <categories
              :form="form"
              @toggle-reorder-mode="reorder_mode = $event"
            />
          </div>
        </div>
        <errors-messages :errors="errors" />
        <b-row align-h="end" v-show="!reorder_mode">
          <b-col cols="auto">
            <confirmation-dialog
              :disabled="loading || form.status_value == 'AVAILABLE'"
              :loading="loading"
              message-title="PUBLICAR?"
              message-body="Tem certeza que deseja publicar este formulário"
              open-class="btn-save ml-1"
              header-class="modal-header-ok"
              open-left-icon="fa-check mr-2"
              open-text="PUBLICAR"
              yesClass="btn-save worksansr"
              @yes="setAvailable"
            />
          </b-col>
        </b-row>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import routes from "../routes";

import api from "../services/api";
import { userData } from "../lib/functions";
import toast from "../lib/ToastNotification";
import FormDetails from "../templates/Semiology/FormDetails";
import Categories from "../templates/Semiology/Categories";
import ErrorsMessages from "../templates/Components/ErrorsMessages.vue";
import ConfirmationDialog from "../templates/Components/ConfirmationDialog.vue";

export default {
  name: "SemiologyForm",
  components: {
    NavBar,
    AuthBySessionExpired,
    FormDetails,
    Categories,
    ErrorsMessages,
    ConfirmationDialog,
  },
  data() {
    return {
      permissions: {},
      errors: [],
      loading: false,

      reorder_mode: false,

      profiles: [],
      residents: [],

      form_id: null,
      /** @type {{
       *    name: string,
       *    description: string,
       *    rest_home_id: number,
       *    id: number,
       *    semiology_form_status_id: number,
       *    status_name: ("ABERTO"|"DISPONÍVEL"|"DESATIVADO"),
       *    status_value: ("OPEN"|"AVAILABLE"|"INACTIVE"),
       *    created_at: Date,
       *    updated_at: Date,
       *    profiles: {
       *      id: number,
       *      name: string,
       *      answer: boolean,
       *      read: boolean,
       *      edit: boolean,
       *    }[],
       *    degrees_of_dependence: { id: number, name: string, value: number }[],
       *    residents: { id: number, name: string }[],
       *  }} formulário
       */
      form: {
        name: "",
        description: "",
        rest_home_id: null,
        id: null,
        semiology_form_status_id: null,
        status_name: "",
        status_value: "",
        created_at: new Date(),
        updated_at: new Date(),
        profiles: [],
        residents: [],
      },

      categories: [],
    };
  },
  created() {
    this.permissions = userData().permissions;
    const { id } = routes.history.current.params;
    this.form_id = id;
    this.retrieve();
  },
  methods: {
    async retrieve() {
      await this.getResidents();
      await this.getForm();
    },

    /** formulário */
    async getForm() {
      try {
        this.loading = true;

        const params = { id: this.form_id };
        const response = await api.get("/rest-home/semiology/form", { params });
        const { error, errors, form } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.form = form;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async removeForm() {
      try {
        this.loading = true;

        const params = {
          form_id: this.form_id,
        };
        const response = await api.delete("/rest-home/semiology/form", {
          params,
        });
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$router.push({ name: "semiology-forms" });
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async duplicate() {
      try {
        this.loading = true;

        const data = { origin_form_id: this.form_id };
        const response = await api.post("/rest-home/semiology/form/copy", data);
        const { error, errors, message, new_semiology_form_id } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          routes.push({
            name: "semiology-form",
            params: { id: new_semiology_form_id },
          });
          window.location.reload();
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async setAvailable() {
      try {
        this.loading = true;

        const data = {
          form_id: this.form_id,
        };
        const response = await api.patch(
          "/rest-home/semiology/form/set-available",
          data
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.getForm();
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getResidents() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/active-residents");
        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = residents;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
